export function injectGoogleApi() {
	const scriptEl = document.createElement("script");

	scriptEl.src = "https://www.google.com/recaptcha/api.js";
	scriptEl.async = true;
	scriptEl.defer = true;

	document.getElementsByTagName("head")[0].appendChild(scriptEl);
}
